import { FilterListOutlined } from '@mui/icons-material';
import { Box, Button, styled } from '@mui/material';

export const ExpandPopoverButton = ({
  onClick,
  children,
  showArrow = true,
  removeButton,
}: {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  showArrow?: boolean;
  removeButton?: React.ReactNode;
}) => {
  return (
    <StyledButton
      disableTouchRipple
      disableFocusRipple
      onClick={onClick}
      data-testid='expand-popover-button'
      data-show-arrow={showArrow}
    >
      {children}
      {removeButton && <span data-testid='remove-button'>{removeButton}</span>}
      {showArrow && !removeButton && (
        <FilterListOutlined
          sx={{
            fontSize: '16px',
            color: 'text.secondary',
          }}
          data-testid='popover-arrow'
        />
      )}
    </StyledButton>
  );
};

export const StyledButton = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 'calc(100% + 8px)',
  marginLeft: '-6px',
  textTransform: 'none',
  backgroundColor: 'transparent',
}));

const StyleFilterPopoverValue = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '6px',
  padding: '0 6px',
  border: `1px solid ${theme.palette.divider}`,
  display: 'inline-block',
  maxWidth: '220px',
  width: 'fit-content',
}));

export const FilterPopoverValue = (properties: React.ComponentProps<typeof StyleFilterPopoverValue>) => (
  <StyleFilterPopoverValue {...properties} data-testid='filter-popover-value' />
);
